var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.418 2.67188H1.58203C0.707941 2.67188 0 3.38421 0 4.25391V13.7461C0 14.621 0.713145 15.3281 1.58203 15.3281H16.418C17.2847 15.3281 18 14.6239 18 13.7461V4.25391C18 3.38576 17.2949 2.67188 16.418 2.67188ZM16.1964 3.72656L10.1187 9.77228C9.81984 10.0711 9.42258 10.2356 9 10.2356C8.57742 10.2356 8.18016 10.0711 7.88034 9.77129L1.80359 3.72656H16.1964ZM1.05469 13.5314V4.46924L5.61227 9.00281L1.05469 13.5314ZM1.80425 14.2734L6.36005 9.74661L7.13556 10.518C7.63358 11.0161 8.29571 11.2903 9 11.2903C9.70429 11.2903 10.3664 11.0161 10.8635 10.519L11.64 9.74661L16.1957 14.2734H1.80425ZM16.9453 13.5314L12.3877 9.00281L16.9453 4.46924V13.5314Z",
    fill: "#00346B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/EmailIcon.d0920a1ef0a09982a8ed04a3831a385b.svg";
export { ForwardRef as ReactComponent };